import {HelmetProvider} from '@dr.pogodin/react-helmet';
import {i18n} from '@online-offer/i18n';
import {ComponentsProvider} from 'platform/components';
import {AppLanguage, getDefaultLocaleByAppLanguage, LocaleProvider} from 'platform/locale';
import {StyleSheetManager} from 'styled-components';

import {ReactNode} from 'react';
import {Provider} from 'react-redux';

import {queryParams} from '../../consts/queryParams';
import {GlobalStyles} from '../../GlobalStyles';
import {store} from '../../store';
import {getWorkspaceCustomization} from '../../utils/getWorkspaceCustomization';
import {useQueryState} from '../../utils/useQueryState';

interface MainBoundaryProps {
  children: ReactNode;
}

export function MainBoundary(props: MainBoundaryProps) {
  const {theme} = getWorkspaceCustomization();
  const [lang] = useQueryState(queryParams.LNG);

  return (
    <Provider store={store}>
      <StyleSheetManager enableVendorPrefixes>
        <ComponentsProvider theme={theme} t={i18n.t} language={i18n.language}>
          <HelmetProvider>
            <LocaleProvider
              language={lang || i18n.resolvedLanguage}
              config={getDefaultLocaleByAppLanguage((lang || i18n.resolvedLanguage) as AppLanguage)}
            >
              {props.children}
            </LocaleProvider>
            <GlobalStyles />
          </HelmetProvider>
        </ComponentsProvider>
      </StyleSheetManager>
    </Provider>
  );
}
